
import Vue from 'vue';
import {
	CqlTokenData,
	CqlAttributeGroupData,
	CqlGenerator,
	CqlQueryBuilderOptions
} from '@/components/cql/cql-types';
import CqlAttributeGroup from './CqlAttributeGroup.vue';

import useModel from './useModel';

export default useModel<CqlTokenData>().extend({
	components: {
		CqlAttributeGroup
	},
	props: {
		options: { type: Object as () => CqlQueryBuilderOptions, required: true },
		canMoveLeft: { type: Boolean, default: false },
		canMoveRight: { type: Boolean, default: false },
	},
	data() {
		return {
			activeTab: 'attributes' as 'attributes' | 'properties',
		};
	},
	computed: {
		tokenCql(): string {
			return CqlGenerator.tokenCql(this.model);
		}
	},
	methods: {
		updateRootAttributeGroup(updatedGroup: CqlAttributeGroupData) {
			this.model.rootAttributeGroup = updatedGroup;
		},
	}
});
